'use client';

import { ChevronsUpDown } from 'lucide-react';

import { MHButton } from '../buttons/MHButton';
import { MHDropdown } from '../overlays/MHDropdown';

export type MHWorkspaceOption = {
  id: string;
  name: string;
  role?: string | null;
};

interface MHWorkspaceSwitcherProps {
  activeOrganizationId?: string | null;
  activeOrganizationName?: string | null;
  organizations: MHWorkspaceOption[];
  onSelect: (organizationId: string) => void;
  disabled?: boolean;
}

export function MHWorkspaceSwitcher({
  activeOrganizationId,
  activeOrganizationName,
  organizations,
  onSelect,
  disabled = false,
}: MHWorkspaceSwitcherProps) {
  const safeName = (activeOrganizationName?.trim() || 'Workspace');

  return (
    <MHDropdown
      align="right"
      className="w-[min(280px,calc(100vw-40px))]"
      trigger={
        <span className="inline-flex">
          <MHButton
            type="button"
            variant="ghost"
            className="h-11 max-w-[min(280px,calc(100vw-172px))] min-w-0 justify-between gap-2 px-0 text-body text-text-1 hover:bg-transparent"
            aria-label="Switch workspace"
            disabled={disabled}
          >
            <span className="truncate">{safeName}</span>
            <ChevronsUpDown className="h-4 w-4 shrink-0 text-text-3" />
          </MHButton>
        </span>
      }
      items={organizations.map((org) => ({
        label: org.name,
        onClick: () => onSelect(org.id),
        disabled: disabled || org.id === activeOrganizationId,
      }))}
    />
  );
}
